"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5690],{

/***/ 93127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38464);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91864);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92570);
/* harmony import */ var _components_common_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63732);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48163);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96261);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 14px;\n  width: 14px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 15px;\n  width: 23px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n      display: inline-flex;\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n      align-items: flex-start;\n      gap: 10px;\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab-badge {\n        height: 30px;\n        padding: ",
        "px ",
        "px;\n        display: inline-flex;\n        align-items: center;\n        border-radius: 5px;\n      }\n      .active-tab-badge {\n        border: none;\n      }\n      .unactivate-tab-badge {\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            position: sticky;\n            top: 0;\n            ",
        "\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n\n      .peek-tab {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n      }\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid ",
        ";\n          font-weight: 600;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid transparent;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        "px;\n    height: 42px;\n    padding: 0 ",
        "px;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}











var badgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject());
var dateBadgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1());
var badgeTabWrapperCSS = function(isFit, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2()), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.var.gray200);
    };
};
var tabWrapperCSS = function(isFit, top, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), top > 0 ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(top) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("top")), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5()));
    };
};
var tabCSS = function(isActive, isFit) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7()), isActive ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject8(), theme.var.black, theme.var.black) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject9(), theme.var.gray500));
    };
};
var Tab = function(param) {
    var className = param.className, tabs = param.tabs, activeTab = param.activeTab, _fit = param.fit, fit = _fit === void 0 ? false : _fit, _stickyAt = param.stickyAt, stickyAt = _stickyAt === void 0 ? 44 : _stickyAt, onChange = param.onChange, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _type = param.type, type = _type === void 0 ? "default" : _type, lastPeekTabViewDate = param.lastPeekTabViewDate;
    var ref = (0,_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* .useBadgePresets */ .fw)(), newbadge = ref.new;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var randomNum = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.floor(Math.random() * (50 - 20) + 20);
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowRandomNumber = ref1[0], setIsShowRandomNumber = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var lastDate = lastPeekTabViewDate ? new Date(lastPeekTabViewDate) : undefined;
        if (lastDate) {
            lastDate === null || lastDate === void 0 ? void 0 : lastDate.setHours((lastDate === null || lastDate === void 0 ? void 0 : lastDate.getHours()) + 6);
        }
        var now = new Date();
        var isShowRandomNumber = activeTab !== "home_peek" && (!lastDate || (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, lastDate));
        setIsShowRandomNumber(isShowRandomNumber);
    }, []);
    if (type === "badge") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            css: badgeTabWrapperCSS(fit, hideBorder),
            className: "".concat(className, " ").concat(activeTab),
            children: tabs.map(function(tab) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "tab-badge ".concat(tab.value === activeTab ? "active-tab-badge" : "unactivate-tab-badge"),
                    text: tab.value,
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    backgroundColor: tab.value === activeTab ? theme.colors.main500 : theme.true.white,
                    color: tab.value === activeTab ? theme.true.white : theme.true.black,
                    radius: 5,
                    fontSize: 14
                });
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        css: tabWrapperCSS(fit, stickyAt, hideBorder),
        className: className,
        children: tabs.map(function(tab) {
            if (tab.value === "chat-library") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                    css: tabCSS(tab.value === activeTab, fit),
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    children: [
                        tab.label,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: "N"
                        }, newbadge), {
                            css: badgeCSS
                        }))
                    ]
                }, "tab-".concat(tab.label));
            }
            if (tab.value === "home_peek") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                        className: "peek-tab",
                        css: tabCSS(tab.value === activeTab, fit),
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                        },
                        children: [
                            tab.label,
                            isShowRandomNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                                text: "".concat(randomNum)
                            }, newbadge), {
                                css: dateBadgeCSS
                            }))
                        ]
                    })
                }, "tab-".concat(tab.label));
            }
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                css: tabCSS(tab.value == activeTab, fit),
                onClick: function() {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                },
                children: tab.label
            }, "tab-".concat(tab.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tab);
var useTab = function(tabs) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: false,
        withoutReRendering: false,
        refresh: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClickTab: function() {}
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var isMounted = (0,_hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__/* .useMounted */ .s)();
    var replace = options.replace, withoutReRendering = options.withoutReRendering;
    var currentTab = router.query.tab;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), lastPeekTabViewDate = ref[0], setLastPeekTabViewDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentTab || tabs[0].value), activeTab = ref1[0], setActiveTab = ref1[1];
    var onChange = function(tab) {
        var ref;
        options === null || options === void 0 ? void 0 : (ref = options.onClickTab) === null || ref === void 0 ? void 0 : ref.call(options, tab);
        if (tab === "home_peek") {
            var date = new Date();
            setLastPeekTabViewDate(date);
            _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__/* .ParsedStorage.setItem */ .f.setItem("lastPeekTabViewDate", date);
        }
        if ((options === null || options === void 0 ? void 0 : options.refresh) && tab === activeTab) {
            return window.location.reload();
        }
        (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(function() {
            setActiveTab(tab);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isMounted) {
            return;
        }
        if (activeTab && replace && !withoutReRendering) {
            router.replace({
                query: _objectSpreadProps(_objectSpread({}, router.query), {
                    tab: activeTab
                })
            }, undefined, {
                shallow: true,
                scroll: false
            });
        } else if (withoutReRendering) {
            (0,_utils_query__WEBPACK_IMPORTED_MODULE_7__/* .changeQueryWithoutRendering */ .Gu)(_objectSpreadProps(_objectSpread({}, router.query), {
                tab: activeTab
            }));
        }
    }, [
        activeTab
    ]);
    return {
        tabs: tabs,
        activeTab: activeTab,
        onChange: onChange,
        lastPeekTabViewDate: lastPeekTabViewDate,
        setLastPeekTabViewDate: setLastPeekTabViewDate
    };
};


/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91864);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var safeareaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
var SafeArea = function(param) {
    var className = param.className, top = param.top, bottom = param.bottom, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: className,
        css: [
            safeareaCSS,
            top ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top") : undefined,
            bottom ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium) : undefined, 
        ],
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeArea);


/***/ }),

/***/ 60280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91864);
/* harmony import */ var chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67862);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76366);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81946);
/* harmony import */ var _common_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59585);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: scroll;\n\n  .title {\n    ",
        ";\n    text-align: center;\n    line-height: 16px;\n    font-weight: 700;\n    margin-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n  .close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n  }\n\n  p {\n    ",
        ";\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        "px;\n    margin: ",
        "px 0;\n    gap: ",
        "px;\n  }\n\n  ul > li {\n    word-break: break-all;\n    ",
        ";\n    list-style-type: disc;\n    color: ",
        ";\n    line-height: 18.9px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h4 */ .ZT.h4, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xhsmall */ .Ki.xhsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h5 */ .ZT.h5, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14, theme.colors.red500);
};
var CharacterDeleteModal = function(_param) {
    var handleOnConfirm = _param.handleOnConfirm, character = _param.character, props = _objectWithoutProperties(_param, [
        "handleOnConfirm",
        "character"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_5__/* .useWebView */ .B9)().web;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), value = ref[0], setValue = ref[1];
    var handleChangeInput = function(e) {
        setValue(e.currentTarget.value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        web.setIsBottomInputPage(true);
        return function() {
            web.setIsBottomInputPage(false);
        };
    }, [
        web
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({}, props), {
        blocking: false,
        onClose: props.onClose,
        header: false,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: containerCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "close",
                    onClick: function() {
                        return props.onClose();
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "title",
                    children: t("캐릭터 삭제")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                    children: t("정말 {{characterName}} 캐릭터를 삭제하시겠습니까?", {
                        characterName: character.name
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제 시 해당 캐릭터와 대화했던 모든 대화방이 삭제됩니다.")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제를 원하신다면 캐릭터명을 아래 입력하신 후 삭제하기 버튼을 눌러주세요.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .II, {
                    placeholder: "캐릭터명을 입력해주세요",
                    value: value,
                    onChange: handleChangeInput
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* .ModalButton */ .mH, {
                    text: t("삭제하기"),
                    onClick: function() {
                        return handleOnConfirm(character.id);
                    },
                    disabled: value !== character.name
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterDeleteModal);


/***/ }),

/***/ 84928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91864);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
/* harmony import */ var _Frame__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19827);
/* harmony import */ var _SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68877);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .cover {\n    padding-bottom: 62.5%;\n    ",
        ";\n  }\n  .info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ",
        "px;\n    margin-top: ",
        "px;\n\n    div {\n      width: 60%;\n      height: 12px;\n    }\n    div:nth-of-type(1) {\n      width: 20%;\n      height: 20px;\n      margin-bottom: ",
        "px;\n    }\n    div:last-of-type {\n      width: 30%;\n      height: 16px;\n      margin-top: ",
        "px;\n    }\n  }\n  .button {\n    display: flex;\n    justify-content: center;\n    gap: ",
        "px;\n    padding: ",
        "px;\n    margin-bottom: ",
        "px;\n\n    div {\n      width: 130px;\n      height: 40px;\n    }\n    div:last-of-type {\n      width: 40px;\n      height: 40px;\n    }\n  }\n  .situation {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    padding: 0 ",
        "px;\n    column-gap: ",
        "px;\n    row-gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var skeletonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top"), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xhsmall */ .Ki.xhsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxlarge */ .Ki.xxlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xlarge */ .Ki.xlarge);
var CharacterDetailSkeleton = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        css: skeletonCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "cover"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "button",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "situation",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        isDetail: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterDetailSkeleton);


/***/ }),

/***/ 19827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91864);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    background-color: ",
        ";\n  }\n\n  to {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  animation: ",
        " 2s\n    alternate infinite ease-in-out;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var skeletonKeyframe = function(fromColor, toColor) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.keyframes)(_templateObject(), fromColor, toColor);
};
var frameCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.var.gray100, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.small */ .wU.small, skeletonKeyframe(theme.var.gray100, theme.var.gray200));
};
var Frame = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: frameCSS,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Frame);


/***/ }),

/***/ 87682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91864);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76366);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97033);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var nicknameCSS = function(color) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), color && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), color), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxxsmall */ .Ki.xxxsmall);
};
var Nickname = function(param) {
    var id = param.id, nickname = param.nickname, hasHonorPartnership = param.hasHonorPartnership, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.xsmall */ .u8.xsmall : _size;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_3__/* .useUserMarketItemInventory */ .wg)(id), data = ref.data, getDecoration = ref.getDecoration;
    var nicknameDeco = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_2__/* .MarketItemType.userNickname */ .q9.userNickname);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                css: nicknameCSS(nicknameDeco === null || nicknameDeco === void 0 ? void 0 : nicknameDeco.object.textColor),
                children: nickname
            }),
            hasHonorPartnership && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Honor */ .Sk,
                size: size
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Nickname);


/***/ }),

/***/ 83890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useChatCharacterQuery; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var _api_chatbot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23082);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var useChatCharacterQuery = function() {
    var useToggleCharacterLike = function(characterId, queryClient) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.LIKE */ .U7.CHARACTER.LIKE(characterId), function() {
            return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .toggleCharacterLike */ .GV)(characterId);
        }, {
            //낙관적 업데이트
            onMutate: function() {
                var _ref = _asyncToGenerator(function(newLike) {
                    var characterQueryKey, previousCharacter, previousLike;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryClient.cancelQueries({
                                        queryKey: _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.LIKE */ .U7.CHARACTER.LIKE(characterId)
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    queryClient.cancelQueries({
                                        queryKey: _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId)
                                    })
                                ];
                            case 2:
                                _state.sent();
                                characterQueryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId);
                                previousCharacter = queryClient.getQueryData(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId));
                                previousLike = previousCharacter === null || previousCharacter === void 0 ? void 0 : previousCharacter.current_user_like;
                                queryClient.setQueryData(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.LIKE */ .U7.CHARACTER.LIKE(characterId), newLike);
                                queryClient.setQueryData(characterQueryKey, _objectSpreadProps(_objectSpread({}, previousCharacter), {
                                    current_user_like: !(previousCharacter === null || previousCharacter === void 0 ? void 0 : previousCharacter.current_user_like)
                                }));
                                return [
                                    2,
                                    {
                                        previousLike: previousLike,
                                        newLike: newLike,
                                        previousCharacter: previousCharacter
                                    }
                                ];
                        }
                    });
                });
                return function(newLike) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onError: function(err, newLike, context) {
                queryClient.setQueryData(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.LIKE */ .U7.CHARACTER.LIKE(characterId), context === null || context === void 0 ? void 0 : context.previousLike);
                queryClient.setQueryData(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId), context === null || context === void 0 ? void 0 : context.previousCharacter);
            },
            onSettled: function() {
                queryClient.invalidateQueries({
                    queryKey: _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.LIKE */ .U7.CHARACTER.LIKE(characterId)
                });
                queryClient.invalidateQueries({
                    queryKey: _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId)
                });
            }
        });
        return query;
    };
    var useGetCharacterDetail = function(characterId) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(characterId), function() {
            return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .getCharacterDetail */ ._t)(characterId);
        });
        return query;
    };
    return {
        useGetCharacterDetail: useGetCharacterDetail,
        useToggleCharacterLike: useToggleCharacterLike
    };
};


/***/ }),

/***/ 75319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useUserQuery; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72218);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98379);
/* harmony import */ var _api_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9622);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39854);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var useUserQuery = function() {
    var useFetchUser = function(userId, options) {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.ONE */ .U7.USER.ONE(userId), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchUser */ .BT)(userId);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            enabled: !!userId
        }, options));
    };
    var useFetchUserList = function(userIds, options) {
        return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.LIST */ .U7.USER.LIST(userIds), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchUserList */ .ET)(userIds);
        }, _objectSpread({
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(15),
            enabled: !!(userIds === null || userIds === void 0 ? void 0 : userIds.length)
        }, options));
    };
    var useFetchFanClub = function(userId) {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.FAN.INFO */ .U7.FAN.INFO(userId), function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchFanClub */ .YS)(userId);
        }, {
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5)
        });
        return query;
    };
    //me로 옮길 쿼리
    var useFetchMyFanClub = function() {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.MY_FAN_CLUB.INFO */ .U7.MY_FAN_CLUB.INFO, function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchMyFanClub */ .L_)();
        }, {
            staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5),
            cacheTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(5)
        });
        return query;
    };
    var useFetchSocialProviders = function() {
        var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_KEYS.USER.SOCIAL_PROVIDER */ .U7.USER.SOCIAL_PROVIDER, function() {
            return (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .fetchSocialProviders */ .E)();
        });
        return query;
    };
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(email) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postEmailCrendentialToUser */ .U3)(email)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }()), postEmailCredential = ref.mutateAsync;
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(/*#__PURE__*/ _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postMyEmailVerification */ .xS)()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })), postEmailVerification = ref1.mutate;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(param) {
            var social, accessToken, idToken;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        social = param.social, accessToken = param.accessToken, idToken = param.idToken;
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .postSocial */ .ov)(social, accessToken, idToken)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()), postSocialPeristalsis = ref2.mutateAsync;
    var ref3 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function() {
        var _ref = _asyncToGenerator(function(param) {
            var social;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        social = param.social;
                        return [
                            4,
                            (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .disconnectSocial */ .e1)(social)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()), disconnectSocialPeristalsis = ref3.mutateAsync;
    var ref4 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(/*#__PURE__*/ _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_api_user__WEBPACK_IMPORTED_MODULE_2__/* .unregisterUser */ .zD)()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })), deleteUser = ref4.mutateAsync;
    var ref5 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function(reason) {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_1__/* .postReasons */ .DS)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .UniversalReason.unregisterUser */ .D2.unregisterUser, {
            reason: reason
        });
    }), postUnregisterReasons = ref5.mutateAsync;
    return {
        disconnectSocialPeristalsis: disconnectSocialPeristalsis,
        useFetchUser: useFetchUser,
        useFetchUserList: useFetchUserList,
        useFetchFanClub: useFetchFanClub,
        useFetchMyFanClub: useFetchMyFanClub,
        postEmailCredential: postEmailCredential,
        postEmailVerification: postEmailVerification,
        useFetchSocialProviders: useFetchSocialProviders,
        postSocialPeristalsis: postSocialPeristalsis,
        deleteUser: deleteUser,
        postUnregisterReasons: postUnregisterReasons
    };
};


/***/ }),

/***/ 78915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CharacterDetail": function() { return /* binding */ CharacterDetail; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _characterId_; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useChatCharacterQuery.ts
var useChatCharacterQuery = __webpack_require__(83890);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
;// CONCATENATED MODULE: ./hooks/query/useSituationQuery.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useSituationQuery = function() {
    var useGetSituationsByCharacterGroup = function(characterId) {
        var sort = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var situationQueryKey = constants/* QUERY_KEYS.SITUATION.INFO */.U7.SITUATION.INFO(characterId);
        var query = (0,utils_query/* useChatPaginationQuery */.aI)(situationQueryKey, function(param) {
            var pageParam = param.pageParam;
            return (0,chatbot/* fetchSituations */.XZ)({
                character_id: characterId,
                status: "AT",
                sort: sort
            }, pageParam);
        }, _objectSpread({}, options));
        return query;
    };
    return {
        useGetSituationsByCharacterGroup: useGetSituationsByCharacterGroup
    };
};

// EXTERNAL MODULE: ./hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(41785);
// EXTERNAL MODULE: ./hooks/useFirebase.ts + 1 modules
var useFirebase = __webpack_require__(37666);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./hooks/useToast.ts
var useToast = __webpack_require__(95151);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(91864);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(76366);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx
var EFinderImage = __webpack_require__(11247);
// EXTERNAL MODULE: ./components/common/RoundAvatar.tsx
var RoundAvatar = __webpack_require__(81794);
// EXTERNAL MODULE: ./components/common/Tag.tsx
var Tag = __webpack_require__(22252);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
;// CONCATENATED MODULE: ./components/characters/CharacterDetailInfoArea.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CharacterDetailInfoArea_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CharacterDetailInfoArea_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CharacterDetailInfoArea_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding-bottom: 62.5%;\n  ",
        "\n  background-color:",
        ";\n\n  > div {\n    position: absolute;\n    width: 100%;\n    height: 50%;\n    padding: ",
        "px;\n    bottom: 0;\n    color: ",
        ";\n    ",
        "\n  }\n\n  .likeBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: none;\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    z-index: 5;\n    bottom: 20px;\n    right: 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: ",
        "px;\n  margin-bottom: ",
        "px;\n\n  > div {\n    margin-bottom: ",
        "px;\n  }\n\n  h3 {\n    ",
        ";\n  }\n\n  p {\n    ",
        "\n    color:",
        ";\n  }\n  .character-avatar {\n    position: relative;\n  }\n  .new-badge {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    white-space: nowrap;\n  }\n  .characterCreater {\n    ",
        ";\n    color: ",
        ";\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding: 0 47.5px;\n\n  .tagList {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    height: ",
        ";\n    overflow: hidden;\n    gap: ",
        "px;\n\n    .icon-text {\n      display: flex;\n      height: auto;\n      padding: ",
        "px ",
        "px;\n      margin: 0;\n    }\n  }\n\n  .icon-btn {\n    position: absolute;\n    bottom: 6px;\n    right: 35px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding-right: ",
        "px;\n  font-size: ",
        "px;\n  text-align: center;\n  padding: 0 15.5px;\n  margin-bottom: ",
        "px;\n\n  button {\n    position: absolute;\n    margin-left: ",
        "px;\n    bottom: ",
        "px;\n    right: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 22.5px;\n\n  .bar::before {\n    content: '';\n    display: flex;\n    width: 1px;\n    height: 12px;\n    border-radius: 0.5px;\n    background-color: ",
        ";\n    margin: 0 ",
        "px;\n  }\n\n  .cnt {\n    display: flex;\n    align-items: center;\n    gap: ",
        "px;\n    line-height: 14px;\n    ",
        "\n  }\n  .text {\n    line-height: 14.85px;\n    color: ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: ",
        "px;\n\n  button {\n    ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    box-shadow: none;\n    line-height: 16px;\n  }\n  .storyBtn {\n    width: 122px;\n  }\n  .chatBtn {\n    width: 182px;\n  }\n  .play-btn {\n    width: 156px;\n    background: linear-gradient(56.96deg, #04c8d0 19.7%, #1590d4 80.3%);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var BAR_COLOR = "#d9d9d9";
var coverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), (0,css/* safeArea */.BI)("top"), theme.var.gray400, dist_esm/* Spacing.medium */.Ki.medium, theme.var.gray900, (0,css/* linearGradient */.bC)("bottom", "transparent", theme.true.white));
};
var profileCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Typography.h5 */.ZT.h5, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray400, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var tagContainerCSS = function(isOpen) {
    return (0,emotion_react_browser_esm.css)(_templateObject2(), isOpen ? "100%" : "30px", dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall);
};
var summaryCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* FontSizes.small */.TS.small, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall, dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall);
var cntContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), BAR_COLOR, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.h6 */.ZT.h6, theme.var.gray600, dist_esm/* Typography.body11 */.ZT.body11);
};
var buttonContainerCSS = function() {
    return (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.h5 */.ZT.h5);
};
var CharacterDetailInfoArea = function(param) {
    var character = param.character, isNewCharacter = param.isNewCharacter, handleClickTag = param.handleClickTag, handleNavigateUser = param.handleNavigateUser, handleChatButtonClick = param.handleChatButtonClick;
    var ref;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var ref1 = (0,react.useState)(false), isSummaryOpen = ref1[0], setSummaryOpen = ref1[1];
    var ref2;
    var ref3 = _slicedToArray((0,misc/* trimString */.gK)((ref2 = character === null || character === void 0 ? void 0 : character.summary) !== null && ref2 !== void 0 ? ref2 : ""), 2), summary1 = ref3[0], summary2 = ref3[1];
    var ref4 = (0,react.useState)(false), isTagOpen = ref4[0], setIsTagOpen = ref4[1];
    var tagContainerRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(1), rowCount = ref5[0], setRowCount = ref5[1];
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref6 = useFetchUser(character === null || character === void 0 ? void 0 : (ref = character.player) === null || ref === void 0 ? void 0 : ref.user_id), user = ref6.data;
    (0,react.useEffect)(function() {
        var calculateRowCount = function() {
            if (tagContainerRef.current) {
                var containerWidth = tagContainerRef.current.clientWidth;
                var items = tagContainerRef.current.children;
                var gapWidth = 8;
                var currentRowWidth = 0;
                var currentRowCount = 1;
                for(var i = 0; i < items.length; i++){
                    var itemWidth = items[i].clientWidth;
                    if (currentRowWidth + itemWidth + gapWidth * (i - 1) > containerWidth) {
                        currentRowCount++;
                        currentRowWidth = 0;
                    }
                    currentRowWidth += itemWidth + gapWidth * (i - 1);
                }
                setRowCount(currentRowCount);
            }
        };
        calculateRowCount();
    }, [
        isTagOpen,
        tagContainerRef
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: character.cover_image
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: profileCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "character-avatar",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RoundAvatar/* default */.Z, {
                                picture: character.profile_image,
                                size: 80
                            }),
                            isNewCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                                text: "새 캐릭터 등장 \uD83D\uDC40",
                                backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                                fontSize: 10,
                                className: "new-badge"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                        text: (character === null || character === void 0 ? void 0 : character.can_have_visual) ? "비주얼 캐릭터" : "일반 캐릭터",
                        backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                        fontSize: 10,
                        border: true,
                        color: theme.colors.main500
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                        children: character.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: character.greeting
                    }),
                    user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                        className: "characterCreater",
                        onClick: function() {
                            return handleNavigateUser(user.id);
                        },
                        children: [
                            "by ",
                            user.nickname
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: tagContainerCSS(isTagOpen),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "tagList",
                        ref: tagContainerRef,
                        children: character.tags.map(function(item, index) {
                            return /*#__PURE__*/ (0,react.createElement)(Tag/* default */.ZP, _objectSpreadProps(CharacterDetailInfoArea_objectSpread({}, item), {
                                key: "tag_".concat(index),
                                onClick: function() {
                                    return handleClickTag(item.id, item.name);
                                }
                            }));
                        })
                    }),
                    rowCount > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                        className: "icon-btn",
                        onClick: function() {
                            return setIsTagOpen(function(prev) {
                                return !prev;
                            });
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                            icon: isTagOpen ? icon/* ArrowUp */.a2 : icon/* ArrowDown */.K5,
                            size: dist_esm/* Sizes.small */.u8.small,
                            color: theme.var.gray500
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Pad/* default */.Z, {
                children: [
                    character.type === "official" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: summaryCSS,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                className: "multiline",
                                children: [
                                    summary1,
                                    isSummaryOpen && summary2
                                ]
                            }),
                            summary2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                className: "icon-btn",
                                onClick: function() {
                                    return setSummaryOpen(function(prev) {
                                        return !prev;
                                    });
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: isSummaryOpen ? icon/* ArrowUp */.a2 : icon/* ArrowDown */.K5,
                                    size: dist_esm/* Sizes.small */.u8.small,
                                    color: theme.var.gray500
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: cntContainerCSS,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                className: "cnt",
                                children: [
                                    (0,misc/* formatComma */.cO)(character.stat.message_count),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: "text",
                                        children: "플레이 수"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "bar"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                                className: "cnt",
                                children: [
                                    (0,misc/* formatComma */.cO)(character.stat.like_count),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: "text",
                                        children: "좋아요"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        css: buttonContainerCSS,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                            className: "play-btn",
                            onClick: handleChatButtonClick,
                            children: "케미 쌓아보기 \uD83D\uDE0B"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var characters_CharacterDetailInfoArea = (CharacterDetailInfoArea);

;// CONCATENATED MODULE: ./components/characters/CharacterProfile.tsx
function CharacterProfile_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CharacterProfile_templateObject() {
    var data = CharacterProfile_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    CharacterProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterProfile_templateObject1() {
    var data = CharacterProfile_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 ",
        "px;\n\n  .title {\n    ",
        ";\n    padding: 10px 0;\n    margin-bottom: 10px;\n  }\n  .chipContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .chip {\n    ",
        ";\n    padding: 10px ",
        "px;\n    border-radius: ",
        "px;\n    background-color: ",
        ";\n    line-height: 18.9px;\n  }\n  .relationship {\n    width: 100%;\n    padding: ",
        "px;\n  }\n"
    ]);
    CharacterProfile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(CharacterProfile_templateObject(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.large */.Ki.large);
};
var listCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CharacterProfile_templateObject1(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.h5 */.ZT.h5, dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.medium */.wU.medium, theme.var.gray50, dist_esm/* Spacing.medium */.Ki.medium);
};
var CharacterProfile = function(param) {
    var character = param.character;
    var ref, ref1;
    var information = character.information, related_profile = character.related_profile;
    var list = [
        {
            id: "profile",
            title: "\uD83D\uDD0D 프로필",
            value: [
                information.gender,
                information.age + "세",
                information.job
            ]
        },
        {
            id: "relationship_with_character",
            title: "❤️ 나와의 관계",
            value: [
                related_profile.information.relationship
            ]
        },
        {
            id: "personality",
            title: "\uD83C\uDF1F 성격",
            value: (information === null || information === void 0 ? void 0 : (ref = information.personality) === null || ref === void 0 ? void 0 : ref.split(",")) || []
        },
        {
            id: "appearance",
            title: "\uD83D\uDC40 외모",
            value: (information === null || information === void 0 ? void 0 : (ref1 = information.appearance) === null || ref1 === void 0 ? void 0 : ref1.split(",")) || []
        }, 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: containerCSS,
        children: list.map(function(item, idx) {
            return item.value.length === 1 && item.value[0] === "" ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: listCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "title",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "chipContainer",
                        children: item.value.map(function(val, idx) {
                            return val !== "" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "chip ".concat(item.id === "relationship_with_character" && "relationship"),
                                children: val
                            }, "".concat(item.id, "_").concat(idx));
                        })
                    })
                ]
            }, "list_".concat(idx));
        })
    });
};
/* harmony default export */ var characters_CharacterProfile = (CharacterProfile);

// EXTERNAL MODULE: ./utils/chat.ts
var chat = __webpack_require__(42127);
;// CONCATENATED MODULE: ./components/chat/PickLabel.tsx
function PickLabel_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PickLabel_templateObject() {
    var data = PickLabel_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 18px;\n  padding: ",
        "px 5px;\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n  line-height: 135%;\n  border-radius: ",
        "px;\n"
    ]);
    PickLabel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var pickLabelCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(PickLabel_templateObject(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, theme.var.white, dist_esm/* Typography.body11 */.ZT.body11, (0,css/* linearGradient */.bC)("right", theme.colors.main500, "rgba(32, 162, 174, 0.6)"), dist_esm/* Radius.small */.wU.small);
};
var PickLabel = function(param) {
    var situation = param.situation;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var tagTitle = (0,chat/* formatNumberWithUnit */._1)((ref = situation.stat) === null || ref === void 0 ? void 0 : ref.created_chat_room_count);
    if (!tagTitle) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: pickLabelCSS,
        children: t(tagTitle)
    });
};
/* harmony default export */ var chat_PickLabel = (PickLabel);

// EXTERNAL MODULE: ./utils/date.ts + 62 modules
var date = __webpack_require__(35493);
;// CONCATENATED MODULE: ./components/chat/SituationCard.tsx
function SituationCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SituationCard_templateObject() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  position: relative;\n"
    ]);
    SituationCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SituationCard_templateObject1() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n        > h6 {\n          ",
        "\n          display: -webkit-box;\n          word-wrap: break-all;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;\n          padding-top: ",
        "px;\n          margin-bottom: ",
        "px;\n          text-align: center;\n          font-weight: 600;\n          line-height: 100%;\n        }\n      "
    ]);
    SituationCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SituationCard_templateObject2() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n        > h6 {\n          ",
        "\n          line-height: 17.4px;\n          display: -webkit-box;\n          word-wrap: break-all;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          margin-bottom: ",
        "px;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;\n          padding: 0 5px;\n        }\n      "
    ]);
    SituationCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SituationCard_templateObject3() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n  line-height: 14px;\n  margin-top: ",
        "px;\n\n  ",
        "\n\n  > p {\n    ",
        ";\n    line-height: 135%;\n    display: -webkit-box;\n    word-wrap: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-align: center;\n  }\n"
    ]);
    SituationCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SituationCard_templateObject4() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    SituationCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SituationCard_templateObject5() {
    var data = SituationCard_taggedTemplateLiteral([
        "\n  display: flex;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  z-index: 1;\n  gap: ",
        "px;\n\n  .new-badge {\n    ",
        ";\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    SituationCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var situationContainerCSS = (0,emotion_react_browser_esm.css)(SituationCard_templateObject());
var situationInfoCSS = function(isSituation) {
    return (0,emotion_react_browser_esm.css)(SituationCard_templateObject3(), dist_esm/* Spacing.xhsmall */.Ki.xhsmall, isSituation ? (0,emotion_react_browser_esm.css)(SituationCard_templateObject1(), dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall) : (0,emotion_react_browser_esm.css)(SituationCard_templateObject2(), dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xsmall */.Ki.xsmall), dist_esm/* Typography.body14 */.ZT.body14);
};
var situationImgCSS = (0,emotion_react_browser_esm.css)(SituationCard_templateObject4());
var badgeContainerCSS = (0,emotion_react_browser_esm.css)(SituationCard_templateObject5(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Typography.body11 */.ZT.body11);
var SituationCard = function(param) {
    var situation = param.situation, onCardClick = param.onCardClick, isSituation = param.isSituation;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var tagTitle = (0,chat/* formatNumberWithUnit */._1)((ref = situation.stat) === null || ref === void 0 ? void 0 : ref.created_chat_room_count);
    var isNewSituation = (situation === null || situation === void 0 ? void 0 : situation.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(situation === null || situation === void 0 ? void 0 : situation.released_at), {
        days: 3
    })) || false;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: situationContainerCSS,
        onClick: function() {
            return onCardClick(situation.id);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: badgeContainerCSS,
                children: [
                    isNewSituation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, {
                        text: "NEW",
                        className: "new-badge",
                        backgroundColor: isCheming ? "linear-gradient(180deg, #7F00FF, #8E2DE2)" : "linear-gradient(90deg, #04C8D0, #1590D5)",
                        radius: dist_esm/* Radius.small */.wU.small
                    }),
                    tagTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(chat_PickLabel, {
                        situation: situation
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: situationImgCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                    image: situation.image,
                    h: EFinderImage/* EFinderImageSizes.chatbot */.ny.chatbot,
                    radius: 10,
                    width: 160,
                    height: 160,
                    layout: "responsive"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: situationInfoCSS(!!isSituation),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        children: t(situation.title)
                    }),
                    isSituation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "multiline",
                        children: t(situation.description)
                    })
                ]
            })
        ]
    }, situation.id);
};
/* harmony default export */ var chat_SituationCard = (SituationCard);

// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
;// CONCATENATED MODULE: ./components/characters/SituationList.tsx
function SituationList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SituationList_templateObject() {
    var data = SituationList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  padding: 0 ",
        "px;\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    SituationList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SituationList_situationContainerCSS = (0,emotion_react_browser_esm.css)(SituationList_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.medium */.Ki.medium);
var SituationList = function(param) {
    var query = param.query, handleSituationCardClick = param.handleSituationCardClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
        name: "character-situation-list",
        query: query,
        ad: false,
        css: SituationList_situationContainerCSS,
        children: function(item) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(chat_SituationCard, {
                situation: item,
                onCardClick: handleSituationCardClick
            });
        }
    });
};
/* harmony default export */ var characters_SituationList = (SituationList);

// EXTERNAL MODULE: ./components/common/SwipableListContainer.tsx
var SwipableListContainer = __webpack_require__(95728);
// EXTERNAL MODULE: ./components/cheming/CharacterProfileCard.tsx
var CharacterProfileCard = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/cheming/CharacterChemiInfoArea.tsx
function CharacterChemiInfoArea_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CharacterChemiInfoArea_templateObject() {
    var data = CharacterChemiInfoArea_taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  .maker-name {\n    ",
        ";\n    color: ",
        ";\n    text-align: center;\n    margin: 20px 0;\n  }\n  .chemi-container {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    margin-bottom: 20px;\n    margin-top: 12px;\n  }\n\n  .padding16 {\n    padding: 0 16px;\n  }\n\n  .subtitle {\n    padding: 10px 16px;\n    ",
        ";\n  }\n\n  .desc {\n    color: ",
        ";\n    ",
        ";\n    margin-top: -4px;\n    margin-bottom: 4px;\n    padding: 0 16px;\n  }\n\n  .scroll-container {\n    display: flex;\n    flex: 1;\n    overflow-x: auto;\n    gap: 12px;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .chip-container {\n    display: flex;\n    flex: 1;\n    gap: 10px;\n    padding: 10px 16px;\n  }\n  .fill {\n    width: 100%;\n  }\n  .right8 {\n    margin-right: 8px;\n  }\n  .highlight {\n    color: ",
        ";\n  }\n"
    ]);
    CharacterChemiInfoArea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterChemiInfoArea_templateObject1() {
    var data = CharacterChemiInfoArea_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  padding-top: ",
        "px;\n\n  .heart {\n    ",
        ";\n    margin-top: 58px;\n  }\n"
    ]);
    CharacterChemiInfoArea_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CharacterChemiInfoArea_templateObject2() {
    var data = CharacterChemiInfoArea_taggedTemplateLiteral([
        "\n  display: flex;\n  white-space: nowrap;\n  padding: 10px 12px;\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    CharacterChemiInfoArea_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var CharacterChemiInfoArea_containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CharacterChemiInfoArea_templateObject(), css/* HEADER_HEIGHT */.Mz, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray600, dist_esm/* Typography.h5 */.ZT.h5, theme.var.gray500, dist_esm/* Typography.body12_sentence */.ZT.body12_sentence, theme.colors.main700);
};
var characterCardContainerCSS = (0,emotion_react_browser_esm.css)(CharacterChemiInfoArea_templateObject1(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Typography.h5 */.ZT.h5);
var chipCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CharacterChemiInfoArea_templateObject2(), theme.colors.main10, dist_esm/* Radius.medium */.wU.medium, theme.var.gray900, dist_esm/* Typography.body14_sentence */.ZT.body14_sentence);
};
var CharacterChemiInfoArea = function(param) {
    var character = param.character, situationInfo = param.situationInfo, // handleNavigateUser,
    handleClickTag = param.handleClickTag, handleClickStep = param.handleClickStep;
    var ref;
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref1 = useFetchUser(character === null || character === void 0 ? void 0 : (ref = character.player) === null || ref === void 0 ? void 0 : ref.user_id), user = ref1.data;
    var stepTitle = situationInfo.chemi_story.step_set.map(function(v) {
        return "".concat("step" + v.number + ". " + v.title);
    });
    var infoList = [
        {
            id: "step",
            name: "우리의 관계 step",
            value: stepTitle,
            desc: "스텝을 클릭하면 줄거리가 나와요."
        }, 
    ];
    var makerInfo = (situationInfo === null || situationInfo === void 0 ? void 0 : situationInfo.maker_note) ? {
        id: "maker_note",
        name: "\uD83D\uDCAC ".concat(user === null || user === void 0 ? void 0 : user.nickname, "님의 메이커 노트"),
        value: [
            situationInfo === null || situationInfo === void 0 ? void 0 : situationInfo.maker_note
        ]
    } : {
        id: "maker_note",
        name: "\uD83D\uDCAC 메이커 ".concat(user === null || user === void 0 ? void 0 : user.nickname),
        value: []
    };
    var hasMakerNote = !!(situationInfo === null || situationInfo === void 0 ? void 0 : situationInfo.maker_note);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: CharacterChemiInfoArea_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: characterCardContainerCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterProfileCard/* default */.Z, {
                        character: character,
                        handleClickTag: handleClickTag,
                        type: "character"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "heart",
                        children: "\uD83D\uDC98"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterProfileCard/* default */.Z, {
                        character: character.related_profile,
                        handleClickTag: handleClickTag,
                        type: "profile"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "chemi-container",
                children: [
                    infoList.map(function(item) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: "chemi-info",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h5", {
                                    className: "subtitle",
                                    children: item.name
                                }),
                                item.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "desc",
                                    children: item.desc
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                                    className: "scroll-container",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                        className: "chip-container",
                                        children: item.value.map(function(v) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                css: chipCSS,
                                                className: "chip ".concat(item.id === "maker_note" ? "fill" : ""),
                                                onClick: function() {
                                                    return item.id === "step" && handleClickStep();
                                                },
                                                children: v
                                            });
                                        })
                                    })
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "chemi-info",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h5", {
                                className: "subtitle",
                                children: [
                                    !hasMakerNote && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: "right8",
                                        children: "\uD83D\uDCAC 메이커"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: "highlight",
                                        children: hasMakerNote ? "\uD83D\uDCAC ".concat(user === null || user === void 0 ? void 0 : user.nickname) : "".concat(user === null || user === void 0 ? void 0 : user.nickname)
                                    }),
                                    hasMakerNote && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        children: "님의 메이커 노트"
                                    })
                                ]
                            }),
                            hasMakerNote && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "chip-container",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    css: chipCSS,
                                    className: "chip fill",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "multiline",
                                        children: makerInfo.value
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cheming_CharacterChemiInfoArea = (CharacterChemiInfoArea);

;// CONCATENATED MODULE: ./components/cheming/CharacterDetailInfo.tsx
function CharacterDetailInfo_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CharacterDetailInfo_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CharacterDetailInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || CharacterDetailInfo_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function CharacterDetailInfo_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CharacterDetailInfo_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CharacterDetailInfo_arrayLikeToArray(o, minLen);
}
function CharacterDetailInfo_templateObject() {
    var data = CharacterDetailInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    CharacterDetailInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterDetailInfo_templateObject1() {
    var data = CharacterDetailInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 ",
        "px;\n\n  .title {\n    ",
        ";\n    padding: 10px 0;\n    margin-bottom: 10px;\n  }\n  .chipContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .chip {\n    padding: 10px ",
        "px;\n    border-radius: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n    ",
        ";\n    line-height: 150%;\n  }\n  .fill {\n    width: 100%;\n    padding: ",
        "px;\n  }\n"
    ]);
    CharacterDetailInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CharacterDetailInfo_containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(CharacterDetailInfo_templateObject(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.large */.Ki.large);
};
var CharacterDetailInfo_listCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(CharacterDetailInfo_templateObject1(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.h5 */.ZT.h5, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Radius.medium */.wU.medium, theme.var.gray50, theme.var.gray900, dist_esm/* Typography.body14_sentence */.ZT.body14_sentence, dist_esm/* Spacing.medium */.Ki.medium);
};
var CharacterDetailInfo = function(param) {
    var character = param.character, situationInfo = param.situationInfo, _isMyCharacter = param.isMyCharacter, isMyCharacter = _isMyCharacter === void 0 ? false : _isMyCharacter;
    var ref, ref1;
    var information = character.information;
    var list = [
        {
            id: "profile",
            title: "\uD83D\uDD0D 프로필",
            value: [
                information.gender,
                information.age + "세",
                information.job
            ]
        },
        {
            id: "tag",
            title: "⚡ 태그",
            value: character.tags.map(function(v) {
                return "#" + v.name;
            }) || []
        },
        {
            id: "personality",
            title: "\uD83C\uDF1F 성격",
            value: [
                information === null || information === void 0 ? void 0 : information.personality
            ] || 0,
            type: "fill"
        }, 
    ].concat(_toConsumableArray((information === null || information === void 0 ? void 0 : information.appearance) ? [
        {
            id: "appearance",
            title: "\uD83D\uDC40 외모",
            value: [
                information === null || information === void 0 ? void 0 : information.appearance
            ] || 0,
            type: "fill"
        }, 
    ] : []), _toConsumableArray((information === null || information === void 0 ? void 0 : information.backstory) ? [
        {
            id: "backstory",
            title: "\uD83C\uDF0E 세계관",
            value: [
                information === null || information === void 0 ? void 0 : information.backstory
            ] || 0,
            type: "fill"
        }, 
    ] : []), _toConsumableArray(isMyCharacter ? [
        {
            id: "hidden_characteristics",
            title: "\uD83D\uDD12 나만 아는 캐릭터 비밀",
            value: [
                information === null || information === void 0 ? void 0 : information.hidden_characteristics
            ] || 0,
            type: "fill"
        }, 
    ] : []), [
        {
            id: "genre",
            title: "장르 및 소재",
            value: (situationInfo === null || situationInfo === void 0 ? void 0 : (ref = situationInfo.tag_set) === null || ref === void 0 ? void 0 : ref.map(function(v) {
                return "#" + v.name;
            })) || []
        },
        {
            id: "theme",
            title: "그들의 관계",
            value: [
                situationInfo === null || situationInfo === void 0 ? void 0 : (ref1 = situationInfo.chemi_story) === null || ref1 === void 0 ? void 0 : ref1.title
            ] || 0
        }, 
    ]);
    var filterGender = function(value) {
        if (!value) {
            return;
        }
        switch(value){
            case "male":
            case "남자":
                return "남성";
            case "female":
            case "여자":
                return "여성";
            case "unknown":
                return "알 수 없음";
            default:
                return value;
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: CharacterDetailInfo_containerCSS,
        children: list.map(function(item, idx) {
            return item.value.length === 1 && item.value[0] === "" ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: CharacterDetailInfo_listCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "title",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "chipContainer",
                        children: item.value.map(function(val, idx) {
                            return val !== "" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "chip ".concat(item.type),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    className: "multiline150",
                                    children: filterGender(val)
                                })
                            }, "".concat(item.id, "_").concat(idx));
                        })
                    })
                ]
            }, "list_".concat(idx));
        })
    });
};
/* harmony default export */ var cheming_CharacterDetailInfo = (CharacterDetailInfo);

// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/common/Error.tsx + 2 modules
var Error = __webpack_require__(33717);
// EXTERNAL MODULE: ./components/common/Loading.tsx
var Loading = __webpack_require__(30208);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
// EXTERNAL MODULE: ./hooks/useCharacterPost.ts
var useCharacterPost = __webpack_require__(38283);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/modal/ImageModal.tsx
var ImageModal = __webpack_require__(11502);
// EXTERNAL MODULE: ./components/community/CharacterPost.tsx
var CharacterPost = __webpack_require__(1289);
;// CONCATENATED MODULE: ./components/community/CharacterCommunityList.tsx
function CharacterCommunityList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CharacterCommunityList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CharacterCommunityList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CharacterCommunityList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CharacterCommunityList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CharacterCommunityList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var CharacterCommunityList = function(param) {
    var query = param.query, character = param.character;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var userId = (ref = character.player) === null || ref === void 0 ? void 0 : ref.user_id;
    var ref1 = (0,useCharacterPost/* useCharacterPost */.x)(), handleActionSheet = ref1.handleActionSheet, likePost = ref1.likePost, handleNavigatePostDetail = ref1.handleNavigatePostDetail, handleClickImg = ref1.handleClickImg, closeImageModal = ref1.closeImageModal, isImageModalOpen = ref1.isImageModalOpen, selectedImage = ref1.selectedImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "user-post-list",
                query: query,
                border: true,
                children: function(item) {
                    var ref;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        onClick: function() {
                            return handleNavigatePostDetail(character.id, item.id, userId);
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterPost/* default */.Z, CharacterCommunityList_objectSpreadProps(CharacterCommunityList_objectSpread({
                            playerId: character === null || character === void 0 ? void 0 : (ref = character.player) === null || ref === void 0 ? void 0 : ref.user_id
                        }, item), {
                            clip: true,
                            onLike: function(post) {
                                return likePost(post, character.id);
                            },
                            handleActionSheet: function(value, id) {
                                return handleActionSheet(value, id, userId, character.id);
                            },
                            handleClickImg: handleClickImg,
                            imageHeight: 400,
                            commentPreview: item.previewComments
                        }))
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Empty/* default */.Z, {
                query: query,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("아직 후기가 없어요.")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("캐릭터에게 바라는 점을 적거나")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        children: t("재미있던 순간을 자랑해 주세요!")
                    })
                ]
            }),
            selectedImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ImageModal/* default */.Z, {
                open: isImageModalOpen,
                image: selectedImage,
                onClose: closeImageModal
            })
        ]
    });
};
/* harmony default export */ var community_CharacterCommunityList = (CharacterCommunityList);

// EXTERNAL MODULE: ./components/layout/Header.tsx + 1 modules
var Header = __webpack_require__(58761);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./components/modal/CharacterDeleteModal.tsx
var CharacterDeleteModal = __webpack_require__(60280);
// EXTERNAL MODULE: ./components/common/Overlay.tsx + 1 modules
var Overlay = __webpack_require__(90814);
;// CONCATENATED MODULE: ./components/modal/ChemiStepBottomModal.tsx
function ChemiStepBottomModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ChemiStepBottomModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChemiStepBottomModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ChemiStepBottomModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ChemiStepBottomModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ChemiStepBottomModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ChemiStepBottomModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ChemiStepBottomModal_templateObject() {
    var data = ChemiStepBottomModal_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .modal-header {\n    display: flex;\n    position: absolute;\n    top: max(calc(constant(safe-area-inset-top) + 20px));\n    top: max(calc(env(safe-area-inset-top) + 20px));\n\n    right: 20px;\n  }\n  .content-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 200px;\n  }\n  .modal-content {\n    position: absolute;\n    right: 40px;\n    display: flex;\n    ",
        ";\n    color: ",
        ";\n    text-align: center;\n    line-height: 18.9px;\n    margin-top: ",
        "px;\n    z-index: 1000;\n  }\n  .card {\n    display: flex;\n    flex-direction: column;\n\n    .reward-container {\n      color: ",
        ";\n      margin-top: 10px;\n      ",
        ";\n    }–\n  }\n"
    ]);
    ChemiStepBottomModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChemiStepBottomModal_templateObject1() {
    var data = ChemiStepBottomModal_taggedTemplateLiteral([
        "\n    position: relative;\n\n    border-radius: ",
        "px ",
        "px 0px 0px;\n    background-color: ",
        ";\n    color: ",
        ";\n    width: 100vw;\n    max-width: ",
        "px;\n    max-height: 100%;\n    transition: 0.3s;\n    will-change: transform;\n    overflow-x: hidden;\n    ",
        ";\n\n    .theme-title {\n      padding: 0 ",
        "px;\n      margin-top: ",
        "px;\n    }\n\n    .modal-container {\n      padding: 30px 0 20px 0;\n      .content {\n        margin-bottom: ",
        "px;\n      }\n    }\n  "
    ]);
    ChemiStepBottomModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChemiStepBottomModal_templateObject2() {
    var data = ChemiStepBottomModal_taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n\n  .card-container {\n    display: flex;\n    margin-top: 10px;\n    gap: 10px;\n    padding: 0 ",
        "px;\n    padding-bottom: 10px;\n  }\n\n  .mission-container {\n    margin-top: 40px;\n    .mission-title {\n      ",
        ";\n      margin-bottom: ",
        "px;\n      margin-left: 16px;\n    }\n    .msg-count {\n      ",
        ";\n      margin-left: 16px;\n      color: ",
        ";\n    }\n  }\n\n  .mission-card-container {\n    display: flex;\n    gap: 10px;\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    ChemiStepBottomModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChemiStepBottomModal_templateObject3() {
    var data = ChemiStepBottomModal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 320px;\n  height: 100%;\n  padding: 20px 12px 16px 16px;\n  border-radius: ",
        "px;\n  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);\n  position: relative;\n  overflow: hidden;\n  .step_title {\n    ",
        ";\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n  .title {\n    ",
        ";\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: ",
        "px;\n  }\n\n  .desc {\n    ",
        ";\n    color: ",
        ";\n  }\n\n  .progress-container {\n    display: flex;\n    gap: ",
        "px;\n    margin: ",
        "px 0;\n  }\n\n  .value {\n    width: 28px;\n    font-size: 10px;\n    line-height: 10px;\n    color: ",
        ";\n  }\n\n  .time {\n    font-size: 10px;\n    line-height: 10px;\n    color: ",
        ";\n  }\n\n  .lock {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    background-color: rgba(255, 255, 255, 0.7);\n    width: 100%;\n    height: 100%;\n\n    i {\n      position: absolute;\n      opacity: 0.4;\n      top: calc(50% - 15px);\n      left: calc(50% - 15px);\n    }\n  }\n"
    ]);
    ChemiStepBottomModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var ChemiStepBottomModal_containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChemiStepBottomModal_templateObject(), dist_esm/* Typography.body14 */.ZT.body14, theme.var.white, dist_esm/* Spacing.medium */.Ki.medium, theme.colors.main500, dist_esm/* Typography.body10 */.ZT.body10);
};
var modalCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChemiStepBottomModal_templateObject1(), dist_esm/* Radius.large */.wU.large, dist_esm/* Radius.large */.wU.large, theme.overlay.bg, theme.var.black, css/* MAX_WIDTH */.d, (0,css/* safeArea */.BI)("bottom", "padding", dist_esm/* Spacing.medium */.Ki.medium), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.large */.Ki.large, dist_esm/* Spacing.medium */.Ki.medium);
};
var modalWrapCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChemiStepBottomModal_templateObject2(), (0,css/* safeArea */.BI)("top", "padding", 16), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Typography.h6 */.ZT.h6, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray500, dist_esm/* Spacing.large */.Ki.large);
};
var cardCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(ChemiStepBottomModal_templateObject3(), dist_esm/* Radius.small */.wU.small, dist_esm/* Typography.body16 */.ZT.body16, dist_esm/* Typography.body16 */.ZT.body16, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Typography.body11_sentence */.ZT.body11_sentence, theme.var.gray500, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, theme.var.gray500, theme.var.gray500);
};
var ChemiStepBottomModal = function(_param) {
    var chemiStory = _param.chemiStory, props = _objectWithoutProperties(_param, [
        "chemiStory"
    ]);
    var open = props.open;
    if (!open) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Overlay/* default */.Z, ChemiStepBottomModal_objectSpreadProps(ChemiStepBottomModal_objectSpread({}, props), {
        blocking: true,
        css: ChemiStepBottomModal_containerCSS,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            css: modalWrapCSS,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: modalCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "modal-container",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SwipableListContainer/* default */.Z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "card-container",
                            children: chemiStory && (chemiStory === null || chemiStory === void 0 ? void 0 : chemiStory.step_set.sort(function(a, b) {
                                return a.number > b.number ? 1 : -1;
                            }).map(function(item, idx) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "card",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        css: cardCSS,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                                className: "step_title",
                                                children: "step ".concat(item.number, ".")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                                                className: "title",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "desc",
                                                children: item.description
                                            })
                                        ]
                                    }, "bottom_card_".concat(idx))
                                });
                            }))
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ var modal_ChemiStepBottomModal = (ChemiStepBottomModal);

// EXTERNAL MODULE: ./components/skeleton/CharacterDetailSkeleton.tsx
var CharacterDetailSkeleton = __webpack_require__(84928);
// EXTERNAL MODULE: ./api/community.ts
var community = __webpack_require__(1385);
// EXTERNAL MODULE: ./api/event.ts
var api_event = __webpack_require__(64143);
// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./pages/play/characters/[characterId]/index.tsx
function _characterId_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _characterId_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _characterId_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _characterId_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _characterId_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _characterId_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _characterId_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _characterId_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _characterId_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        _characterId_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _characterId_slicedToArray(arr, i) {
    return _characterId_arrayWithHoles(arr) || _characterId_iterableToArrayLimit(arr, i) || _characterId_unsupportedIterableToArray(arr, i) || _characterId_nonIterableRest();
}
function _characterId_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _characterId_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _characterId_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _characterId_arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _characterId_templateObject() {
    var data = _characterId_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    max-width: 500px;\n    height: calc(env(safe-area-inset-bottom) + ",
        "px);\n\n    .floating-button-wrap {\n      position: fixed;\n      display: flex;\n      max-width: inherit;\n      width: 100%;\n      gap: 10px;\n      padding: 10px 16px 20px;\n      border-top: 1px solid ",
        ";\n      z-index: 50;\n      bottom: 0px;\n      background-color: ",
        ";\n\n      .btn {\n        height: 44px;\n      }\n    }\n  "
    ]);
    _characterId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












































var floatingButtonContainerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_characterId_templateObject(), dist_esm/* Spacing.large */.Ki.large + 40, theme.var.gray100, theme.var.white);
};
var __N_SSP = true;
var CharacterDetail = function(param) {
    var id = param.id, isModal = param.isModal;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var shareUUID = router.query.share_uid;
    var queryClient = (0,es.useQueryClient)();
    var characterId = id ? id : (0,utils_query/* getRouterQuery */.Fm)(router.query.characterId);
    var ref4 = (0,global/* useGlobalContext */.bN)(), platform = ref4.platform, isCheming = ref4.isCheming;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var web = (0,webview/* useWebView */.B9)().web;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref5 = (0,hook/* useMe */.Pi)(), me = ref5.data;
    var ref6 = (0,es.useMutation)(api_event/* postCaptureUUID */.vl), postUUID = ref6.mutate;
    var useGetCharacterDetail = (0,useChatCharacterQuery/* useChatCharacterQuery */.S)().useGetCharacterDetail;
    var ref7 = useGetCharacterDetail(characterId), character = ref7.data;
    var useGetSituationsByCharacterGroup = useSituationQuery().useGetSituationsByCharacterGroup;
    var query = useGetSituationsByCharacterGroup(characterId, "desc");
    var characterSituationId = (ref1 = query === null || query === void 0 ? void 0 : (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages[0].items[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_UPDATE */._.CHARACTER_UPDATE, function() {
        queryClient.refetchQueries(constants/* QUERY_KEYS.CHARACTER.ONE */.U7.CHARACTER.ONE(characterId));
    });
    var postChannelMessage = (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_DELETE */._.CHARACTER_DELETE).postChannelMessage;
    var ref8 = (0,es.useQuery)(constants/* QUERY_KEYS.SITUATION.ONE */.U7.SITUATION.ONE(characterSituationId), function() {
        return (0,chatbot/* getAIChatSituationDetail */.Rr)(characterSituationId);
    }, {
        retry: false,
        enabled: !!characterSituationId
    }), situationInfo = ref8.data;
    var chatRoomsQueries = {
        last_chat_in_days: 365,
        ordering: "last_chat_newest",
        status: "AT"
    };
    if (characterId) {
        chatRoomsQueries.character_id = characterId;
    }
    var communityQueryKey = constants/* QUERY_KEYS.POST.CHARACTER_LIST */.U7.POST.CHARACTER_LIST(character === null || character === void 0 ? void 0 : character.id);
    var communityQuery = (0,utils_query/* usePaginationQuery */.Zl)(communityQueryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,community/* fetchCharacterPosts */.Q4)(character === null || character === void 0 ? void 0 : character.id, pageParam);
    }, {
        enabled: !!(character === null || character === void 0 ? void 0 : character.id)
    });
    var _totalCount;
    var communityCount = (_totalCount = (ref2 = communityQuery.data) === null || ref2 === void 0 ? void 0 : ref2.pages[0].totalCount) !== null && _totalCount !== void 0 ? _totalCount : 0;
    var ref9 = _characterId_slicedToArray((0,useModal/* useModal */.d)("chemi-step-bottom-modal"), 2), isChemiBottomModalOpen = ref9[0], ref10 = ref9[1], openChemiBottomModalOpen = ref10.open, closeChemiBottomModalOpen = ref10.close;
    var tabs = (0,Tab/* useTab */.x)(isCheming ? [
        {
            label: t("캐릭터"),
            value: "character"
        },
        {
            label: t("나의 페르소나"),
            value: "profile"
        }, 
    ] : (character === null || character === void 0 ? void 0 : character.type) === "normal" ? [
        {
            label: t("프로필"),
            value: "profile"
        },
        {
            label: t("후기 ".concat(communityCount > 0 ? "(".concat(communityCount, ")") : "")),
            value: "community"
        }, 
    ] : [
        {
            label: t("상황"),
            value: "situation"
        },
        {
            label: t("후기 ".concat(communityCount > 0 ? "(".concat(communityCount, ")") : "")),
            value: "community"
        }, 
    ], {
        replace: false
    });
    var activeTab = tabs.activeTab, changeActiveTab = tabs.onChange;
    var handleOnChangeTab = function(tab) {
        changeActiveTab(tab);
        if (isCheming && tab === "character" || isCheming && tab === "profile") {
            firebase.logEvent("click_character_detail_tab", {
                tap_type: tab,
                character_id: characterId
            });
        }
    };
    var isNewCharacter = (character === null || character === void 0 ? void 0 : character.released_at) && (0,date/* isBefore */.RR)(new Date(), (0,date/* addDuration */.WK)(new Date(character === null || character === void 0 ? void 0 : character.released_at), {
        days: 3
    })) || false;
    var isMyCharacter = me && (me === null || me === void 0 ? void 0 : me.id) === (character === null || character === void 0 ? void 0 : (ref3 = character.player) === null || ref3 === void 0 ? void 0 : ref3.user_id) || false;
    var ref11 = _characterId_slicedToArray((0,useModal/* useModal */.d)("character-delete"), 2), isCharacterDeleteModalOpen = ref11[0], ref12 = ref11[1], openCharacterDeleteModal = ref12.open, closeCharacterDeleteModal = ref12.close;
    var ref13 = (0,es.useMutation)(function(characterId) {
        return (0,chatbot/* deletePlaySet */.o6)(characterId);
    }, {
        onSettled: function() {
            closeCharacterDeleteModal();
            postChannelMessage("delete");
            setTimeout(function() {
                alert("캐릭터 삭제가 완료되었습니다.");
                if (platform === constants/* Platform.web */.t4.web) {
                    router.back();
                }
                web.closePage();
            }, 100);
        }
    }), deleteCharacter = ref13.mutate;
    var ref14 = (0,react.useState)(isMyCharacter ? [
        {
            label: t("수정하기"),
            value: "modify"
        },
        {
            label: t("삭제하기"),
            value: "delete",
            isDanger: true
        }, 
    ] : [
        {
            label: t("신고하기"),
            value: "report",
            isDanger: true
        }
    ]), actions = ref14[0];
    var handleActionSheet = function(value) {
        switch(value){
            case "modify":
                var type = (character === null || character === void 0 ? void 0 : character.can_have_visual) ? "visual" : "default";
                if (isModal && !isCheming) {
                    web.openPage("/play/characters/".concat(characterId, "/edit?characterType=").concat(type));
                } else {
                    router.push("/play/characters/".concat(characterId, "/edit?characterType=").concat(type));
                }
                return;
            case "delete":
                openCharacterDeleteModal();
                return;
            case "report":
                if (isModal) {
                    web.openPage("/report".concat((0,misc/* toQueryString */.UK)({
                        objectType: constants/* ReportObjectType.character */.LB.character,
                        object_id: characterId
                    })));
                } else {
                    router.push("/report".concat((0,misc/* toQueryString */.UK)({
                        objectType: constants/* ReportObjectType.character */.LB.character,
                        object_id: characterId
                    })));
                }
                return;
        }
    };
    var handleConfirmDeleteCharacter = function(characterId) {
        deleteCharacter(characterId);
    };
    var handleSituationCardClick = function(id) {
        if (!id) {
            return;
        }
        setTimeout(function() {
            if (platform === constants/* Platform.web */.t4.web && id) {
                return router.push("/play/situations/".concat(id, "/chat-room"));
            } else {
                return web.openPage("/play/situations/".concat(id, "/chat-room"));
            }
        }, 300);
        firebase.logEvent("test_chatbot_character_detail_action", {
            target: "situation",
            action_type: "click"
        });
    };
    var handleStoryButtonClick = function() {
        firebase.logEvent("test_chatbot_character_detail_action", {
            target: "story",
            action_type: "click"
        });
        if (character === null || character === void 0 ? void 0 : character.story_id) {
            inflow(character === null || character === void 0 ? void 0 : character.story_id);
            if (isModal) {
                web.openPage("/stories/".concat(character === null || character === void 0 ? void 0 : character.story_id));
            } else {
                router.push("/stories/".concat(character === null || character === void 0 ? void 0 : character.story_id));
            }
        } else {
            alert("작품이 존재하지 않는 캐릭터입니다.");
        }
    };
    var handleModifyMyCharacter = function() {
        var type = (character === null || character === void 0 ? void 0 : character.can_have_visual) ? "visual" : "default";
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character === null || character === void 0 ? void 0 : character.id, "/edit?characterType=").concat(type));
        } else {
            web.openPage("/play/characters/".concat(character === null || character === void 0 ? void 0 : character.id, "/edit?characterType=").concat(type));
        }
    };
    var getPathOnly = function(url) {
        return url.split("?")[0].split("#")[0];
    };
    var goToUrlOrRefresh = function(url) {
        var currentPath = getPathOnly(router.asPath);
        var targetPath = getPathOnly(url);
        if (currentPath === targetPath) {
            window.location.reload();
        } else {
            router.push(url);
        }
    };
    var handleChatButtonClick = function() {
        var _ref = _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                (0,misc/* setFlow */.kB)({
                    name: "대화하기"
                });
                firebase.logEvent("test_chatbot_character_detail_action", {
                    target: "chat",
                    action_type: "click"
                });
                if (platform === constants/* Platform.web */.t4.web) {
                    return [
                        2,
                        goToUrlOrRefresh("/play/situations/".concat(characterSituationId, "/chat-room"))
                    ];
                } else {
                    return [
                        2,
                        web.openPage("/play/situations/".concat(characterSituationId, "/chat-room"))
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function handleChatButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNavigateUser = function(id) {
        if (isModal) {
            web.openPage("/users/".concat(id));
        } else {
            router.push("/users/".concat(id));
        }
    };
    var handleClickTag = function(id, name) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/tags/".concat(id, "?title=").concat(name));
        } else {
            web.openPage("/play/characters/tags/".concat(id, "?title=").concat(name));
        }
    };
    var handleNavigatePostCreate = function() {
        var _ref = _asyncToGenerator(function(e) {
            var data, isCreatePostAvailable, ref, ref1;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        return [
                            4,
                            (0,chatbot/* fetchChatRooms */.PL)({
                                character_id: characterId
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        isCreatePostAvailable = data.items.length > 0 || isMyCharacter;
                        if (isCreatePostAvailable) {
                            ;
                            if (platform === constants/* Platform.web */.t4.web) {
                                ;
                                router.push("/play/characters/posts/create".concat((0,misc/* toQueryString */.UK)({
                                    characterId: characterId,
                                    playerId: character === null || character === void 0 ? void 0 : (ref1 = character.player) === null || ref1 === void 0 ? void 0 : ref1.user_id
                                })));
                            }
                            web.openPage("/play/characters/posts/create".concat((0,misc/* toQueryString */.UK)({
                                characterId: characterId,
                                playerId: character === null || character === void 0 ? void 0 : (ref = character.player) === null || ref === void 0 ? void 0 : ref.user_id
                            })));
                        } else {
                            showToast({
                                text: t("캐릭터와 대화를 나누면 글을 작성할 수 있어요!\n플레이 해보세요 ❤️"),
                                height: 100
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNavigatePostCreate(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickStep = function() {
        openChemiBottomModalOpen();
    };
    (0,react.useEffect)(function() {
        (0,misc/* setFlow */.kB)({
            name: "캐릭터상세"
        });
    }, []);
    (0,react.useEffect)(function() {
        firebase.logEvent("chatbot_character_inflow", {
            character_id: characterId,
            source: (0,misc/* getFlow */.ME)()
        });
    }, [
        characterId,
        firebase
    ]);
    (0,react.useEffect)(function() {
        if (shareUUID) {
            postUUID(shareUUID);
        }
    }, [
        shareUUID
    ]);
    if (!character) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Error/* ErrorFallback */.H, {
            status: 404
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SafeArea/* default */.Z, {
            bottom: true,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Header/* default */.Z, {
                    transparent: isModal || isCheming ? false : true,
                    transparentFadeInAt: isCheming ? "0px" : "100px",
                    hideBorder: isCheming ? true : false,
                    title: isCheming && "캐릭터 정보",
                    push: false,
                    hideBackButton: isModal,
                    right: function(color) {
                        return isMyCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* default */.Z, {
                            name: "my-story-action",
                            options: actions,
                            onSelect: handleActionSheet,
                            children: function(open) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    className: "icon-btn",
                                    onClick: open,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                        icon: icon/* VerticalEllipsis */.oR,
                                        color: color,
                                        size: dist_esm/* Sizes.medium */.u8.medium
                                    })
                                });
                            }
                        });
                    }
                }),
                isCheming && situationInfo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(cheming_CharacterChemiInfoArea, {
                    character: character,
                    handleClickTag: handleClickTag,
                    handleClickStep: handleClickStep,
                    situationInfo: situationInfo
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterDetailInfoArea, {
                    character: character,
                    isNewCharacter: isNewCharacter,
                    handleClickTag: handleClickTag,
                    handleNavigateUser: handleNavigateUser,
                    handleChatButtonClick: handleChatButtonClick
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, _characterId_objectSpreadProps(_characterId_objectSpread({}, tabs), {
                    fit: true,
                    onChange: handleOnChangeTab
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                    fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                        push: true
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            activeTab === "situation" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_SituationList, {
                                query: query,
                                handleSituationCardClick: handleSituationCardClick
                            }),
                            activeTab === "community" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(community_CharacterCommunityList, {
                                query: communityQuery,
                                character: character
                            }),
                            isCheming && activeTab === "character" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(cheming_CharacterDetailInfo, {
                                character: character,
                                situationInfo: situationInfo,
                                isMyCharacter: isMyCharacter
                            }),
                            isCheming && activeTab === "profile" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(cheming_CharacterDetailInfo, {
                                character: character.related_profile,
                                situationInfo: situationInfo,
                                isMyCharacter: isMyCharacter
                            }),
                            !isCheming && activeTab === "profile" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterProfile, {
                                character: character
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    css: floatingButtonContainerCSS,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "floating-button-wrap",
                        children: [
                            !isMyCharacter && !!(character === null || character === void 0 ? void 0 : character.story_id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                className: "btn",
                                type: "border",
                                onClick: handleStoryButtonClick,
                                children: "작품 볼래요"
                            }),
                            !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                className: "btn",
                                onClick: handleNavigatePostCreate,
                                type: "border",
                                children: "후기 쓰기"
                            }),
                            isMyCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                className: "btn",
                                type: "border",
                                onClick: handleModifyMyCharacter,
                                children: "캐릭터 수정"
                            }),
                            isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                className: "btn",
                                type: "fill",
                                onClick: handleChatButtonClick,
                                children: isModal ? "새로 대화하기 \uD83D\uDE09" : "우린 어떤 사이가 될까요? \uD83E\uDD2B"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_ChemiStepBottomModal, {
                    open: isChemiBottomModalOpen,
                    onClose: closeChemiBottomModalOpen,
                    chemiStory: situationInfo === null || situationInfo === void 0 ? void 0 : situationInfo.chemi_story
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Push/* default */.Z, {
                    size: Push/* PushSize.floatingButton */.z.floatingButton
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                    fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                        center: true
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterDeleteModal/* default */.Z, {
                        open: isCharacterDeleteModalOpen,
                        onClose: closeCharacterDeleteModal,
                        handleOnConfirm: handleConfirmDeleteCharacter,
                        character: character
                    })
                })
            ]
        })
    });
};
/**
 * Page
 */ var CharacterDetailLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterDetailSkeleton/* default */.Z, {})
    });
};
var CharacterDetailPage = function() {
    (0,hook/* useScreen */.EV)("캐릭터 상세");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
        fallback: CharacterDetailLoading(),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterDetail, {})
    });
};
/* harmony default export */ var _characterId_ = ((0,auth/* withAuth */.QO)(CharacterDetailPage, {
    isSignInRequired: false,
    LoadingComponent: CharacterDetailLoading
}));


/***/ })

}]);